export default __webpack_public_path__ + "static/media/ppg_1.6673b28b.png";